import { createAction, createReducer } from "@reduxjs/toolkit";

export const setLoadedMoat = createAction('setLoadedMoat')
export const resetLoadedMoat = createAction('resetLoadedMoat')

const initialState = {
    value: "",
    index: ""
};

export const loadedMoat = createReducer(initialState, {
    [setLoadedMoat]: (state, action) => {
        state.value = action.payload
    },
    [resetLoadedMoat]: (state, action) => {
        state.value = initialState
    }
}
);

//use in:
// Moatlist.js
// Signmoat - setLoadedMoat is used to reassign the loaded moat status to the previous moat when the new moat signature is unsuccessful
